import {
  FETCH_BLOGPOSTS,
  FETCH_SI_POLICIES,
  FETCH_TRANSACTIONS,
  VALIDATE_WARRANTY_ISSUED_ERROR,
  VALIDATE_WARRANTY_ISSUED_RESPONSE,
  VALIDATE_WARRANTY_ISSUED_START,
  WARRANTY_LOADED,
  WARRANTY_RESPONSE,
  WARRANTY_SELECT,
  WARRANTY_SUBMIT,
  SET_D2C_IS_INSTALLED,
} from 'customer/actions/actionTypes'

const initialState = {
  cancellingWarranty: null,
  hasSubmitError: false,
  isLoading: false,
  selectedWarranty: 0,
  shippingInsurancePolicies: [],
  total_warranty_count: null,
  transactions: null,
  validateWarrantyErrorMessage: null,
  warranties: [],
  D2CExtensionInstalled: false,
}

export default function warranty(state = initialState, action) {
  switch (action.type) {
    case WARRANTY_SUBMIT:
      return state
    case WARRANTY_RESPONSE:
      return Object.assign({}, state, {
        warranties: action.warranties,
        total_warranty_count: action.total_warranty_count,
      })
    case WARRANTY_SELECT:
      return Object.assign({}, state, {
        isLoading: true,
        selectedWarranty: action.index,
      })
    case WARRANTY_LOADED:
      return Object.assign({}, state, {
        isLoading: false,
      })
    case FETCH_BLOGPOSTS:
      return {
        ...state,
        blogposts: action.payload.posts,
      }
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.transactions,
      }
    case FETCH_SI_POLICIES:
      return {
        ...state,
        shippingInsurancePolicies: action.payload.policies,
      }
    case VALIDATE_WARRANTY_ISSUED_START:
      return {
        ...state,
        validateWarrantyErrorMessage: null,
        hasSubmitError: false,
      }
    case VALIDATE_WARRANTY_ISSUED_RESPONSE:
      return {
        ...state,
        cancellingWarranty: action.payload,
      }
    case VALIDATE_WARRANTY_ISSUED_ERROR:
      return {
        ...state,
        cancellingWarranty: null,
        validateWarrantyErrorMessage: action.message,
      }
    case SET_D2C_IS_INSTALLED:
      return Object.assign({}, state, {
        D2CExtensionInstalled: Boolean(action.value),
      })
    default:
      return state
  }
}
